import { createContext, useContext, useState, useCallback } from "react";

const Ctx = createContext(null);

export function RestrictedVaultProvider({ children }) {
  const [state, setState] = useState({ open: false, clientId: "", intakeId: "", tab: "" });
  const openVault = useCallback((opts = {}) => {
    setState({ open: true, clientId: opts.clientId || "", intakeId: opts.intakeId || "", tab: opts.tab || "" });
  }, []);
  const closeVault = useCallback(() => setState((s) => ({ ...s, open: false })), []);
  return <Ctx.Provider value={{ ...state, openVault, closeVault }}>{children}</Ctx.Provider>;
}

export function useRestrictedVault() {
  return useContext(Ctx);
}
